<template>
  <div class="dpp-editor">
    <h4 class="main-header" ref="mainHeader">
      <span class="breadcrumb-link" @click="goTo('products')">{{ $t('products') }}</span> &gt;
      <span class="breadcrumb-link" @click="goToProductDetails('info')">{{ product.name }}</span> &gt;
      <span class="breadcrumb-link" @click="goToProductDetails('redirection')">{{ $t('scan_destination') }}</span> &gt;
      {{ $t('digital_product_passport') }}
    </h4>
    <v-progress-linear
      v-show="loading"
      indeterminate
      color="primary"
    ></v-progress-linear>
    <iframe id="dpp-frame" v-if="editorUrl" frameborder="0" :src="editorUrl" :style="{ height: iframeHeight, maxHeight: iframeHeight }"></iframe>
  </div>
</template>

<script>

import Api from '@/api'
import amplitude from 'amplitude-js'
import { mapGetters } from 'vuex'

export default {
  name: 'DppEditor',
  computed: {
    ...mapGetters(['scantrustAuthToken', 'selectedProduct'])
  },
  data () {
    return {
      messageListener: null,
      loading: true,
      product: {},
      iframeHeight: '100vh',
      editorUrl: ''
    }
  },
  methods: {

    goTo (route) {
      this.$router.push({ name: route })
    },

    goToProductDetails (tab) {
      this.$router.push({ name: `products.${tab}`, params: { id: this.product.id, tab: tab, product: this.product } })
    },

    initEventHandler () {
      const eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent'
      const messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message'

      this.messageListener = (e) => {
        if (e.data.type === 'editor.loaded') {
          this.loading = false
        } else if (e.data.type === 'editor.navigation') {
          if (~e.data.hash.indexOf('#')) {
            this.$router.push(e.data.hash.split('#')[1])
          }
        }
      }
      window[eventMethod](messageEvent, this.messageListener)
    },

    updateIframeHeight () {
      this.$nextTick(() => {
        const header = this.$refs.mainHeader
        const headerH = header ? header.offsetHeight : 0
        const viewportH = window.innerHeight || document.documentElement.clientHeight
        this.iframeHeight = `calc(${viewportH}px - ${headerH}px)`
      })
    }
  },
  async created () {
    amplitude.getInstance().logEvent('DPP Editor Opened')
    const productId = this.$route.params.id
    if (this.selectedProduct && this.selectedProduct.id === productId) {
      this.product = this.selectedProduct
    } else {
      this.product = await this.$store.dispatch('loadProduct', productId)
    }
    this.editorUrl = `${Api.dpp_editor_url}#/edit/${productId}/form?token=${this.scantrustAuthToken}`
    this.initEventHandler()
    this.updateIframeHeight()
    window.addEventListener('resize', this.updateIframeHeight)
  },
  beforeDestroy () {
    const eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent'
    const messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message'

    window.removeEventListener(messageEvent, this.messageListener)
    window.removeEventListener('resize', this.updateIframeHeight)
  }
}

</script>

<style lang="sass" scoped>

.dpp-editor
  font-family: 'Roboto mono'
  height: 100%
  width: 100%

iframe
  overflow: hidden
  width: 100%
  min-width: 100%
  display: block

</style>
